import { __assign } from "tslib";
import * as React from 'react';
import { default as MuiTableSortLabel, } from '@material-ui/core/TableSortLabel';
import { SortableArrows } from '../../internal/icons/small/SortableArrows';
import { SortableArrowUp } from '../../internal/icons/small/SortableArrowUp';
var ActiveIcon = function (props) { return (React.createElement(SortableArrowUp, __assign({ "data-testid": "active", fontSize: "small" }, props))); };
var DefaultIcon = function (props) { return (React.createElement(SortableArrows, __assign({ "data-testid": "default", fontSize: "small" }, props))); };
export var TableSortLabel = React.forwardRef(function (props, ref) {
    var active = props.active;
    return (React.createElement(MuiTableSortLabel, __assign({ IconComponent: active ? ActiveIcon : DefaultIcon, ref: ref }, props)));
});
export default TableSortLabel;
//# sourceMappingURL=TableSortLabel.js.map